import React, { ReactNode, useMemo } from 'react';
import Header from 'components/Header';
import { Box, BoxProps, Container, Grid } from '@mui/material';
import LayoutTitle from './LayoutTitle';
import { useTheme } from '@mui/material';

interface Props extends Omit<BoxProps, 'title' | 'right' | 'left'> {
  title?: ReactNode;
  header?: boolean;
  footer?: boolean;
  profile?: boolean;
  left?: ReactNode;
  right?: ReactNode;
  rightSticky?: boolean;
  leftSticky?: boolean;
  children: ReactNode;
  noPadding?: boolean;
}

const Layout = ({
  title,
  header = true,
  footer = true,
  profile = true,
  children,
  left,
  right,
  leftSticky = false,
  rightSticky = false,
  noPadding = false,
  ...rest
}: Props) => {
  const theme = useTheme();

  const stickyStyle = { alignSelf: 'flex-start', position: 'sticky', top: theme.spacing(9) };
  const desktopCenterGridSize = useMemo(() => {
    if (left && right) {
      return 6;
    } else if (left || right) {
      return 8;
    } else {
      return 12;
    }
  }, [left, right]);

  return (
    <Box {...rest}>
      {header && <Header />}
      <Container
        component="main"
        sx={{
          paddingTop: noPadding === true ? 0 : theme.spacing(10),
          paddingBottom: noPadding === true ? 0 : theme.spacing(6),
          maxWidth: 800,
        }}
      >
        {title && (
          <Grid container sx={{ marginBottom: theme.spacing(3) }}>
            <Grid item xs>
              {title}
            </Grid>
          </Grid>
        )}
        <Grid container spacing={2}>
          {left && (
            <Grid
              item
              xs={12}
              lg={right ? 3 : 4}
              sx={[
                {
                  [theme.breakpoints.down('md')]: {
                    order: 2,
                  },
                },
                leftSticky && stickyStyle,
              ]}
            >
              {left}
            </Grid>
          )}
          <Grid
            item
            xs={12}
            lg={desktopCenterGridSize}
            sx={{
              [theme.breakpoints.down('md')]: {
                order: 1,
              },
            }}
          >
            {children}
          </Grid>
          {right && (
            <Grid
              item
              xs={12}
              lg={left ? 3 : 4}
              sx={[
                {
                  [theme.breakpoints.down('md')]: {
                    order: 3,
                  },
                },
                rightSticky && stickyStyle,
              ]}
            >
              {right}
            </Grid>
          )}
        </Grid>
      </Container>
      {profile && (
        <Box
          sx={{
            marginTop: theme.spacing(8),
          }}
        >
          {/* <Profile /> */}
        </Box>
      )}
      {/* {footer && <Footer />} */}
    </Box>
  );
};

Layout.Title = LayoutTitle;

export default Layout;
